module.exports = __webpack_public_path__ + "img/image_4.0233d224.jpg";